import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { inputCls } from "./SectionEditor";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("settld-admin-token", r.data.token);
      onLogin(r.data.token);
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-midnight px-5">
      <form
        data-testid="admin-login-form"
        onSubmit={submit}
        className="w-full max-w-sm rounded-3xl bg-white p-8 shadow-2xl"
      >
        <div className="flex items-center gap-2.5">
          <img src="/assets/logo-mark-badge.png" alt="Settld" className="h-10 w-10 rounded-xl" />
          <span className="font-sans text-xl font-extrabold tracking-tight text-ink">
            Settld<span className="text-aqua-500">.</span> <span className="text-sm font-bold text-slate-400">Admin</span>
          </span>
        </div>
        <div className="mt-7 space-y-4">
          <label className="block">
            <span className="mb-1.5 block text-xs font-bold uppercase tracking-[0.12em] text-slate-500">Email</span>
            <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="admin@settld.ai" />
          </label>
          <label className="block">
            <span className="mb-1.5 block text-xs font-bold uppercase tracking-[0.12em] text-slate-500">Password</span>
            <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
          </label>
        </div>
        <button
          data-testid="admin-login-submit-btn"
          type="submit"
          disabled={busy}
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-maple py-3.5 text-sm font-bold text-white transition-colors hover:bg-[#C23225] disabled:opacity-60"
        >
          {busy ? <Loader2 size={16} className="animate-spin" /> : "Sign In"}
        </button>
      </form>
    </div>
  );
}
